import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const PROMO_LINE_HEIGHT = 40;

export const HatLink = styled.a<{ image: string }>`
    display: flex;
    height: inherit;
    width: inherit;
    background-image: url(${p => p.image});
    background-size: auto 100%;
`;

export const HatWrapperWithIndent = styled.div`
    width: inherit;
    height: ${PROMO_LINE_HEIGHT}px;
    background-color: ${COLORS.BgMain};
    z-index: 11;

   > [id='hat'] {
        background-color: inherit;
        width: inherit;
        height: inherit;
        position: fixed;
        z-index: 12;
    }
`;


